@if (isAuthenticated) {
  <div>
    <router-outlet></router-outlet>
  </div>
}

<router-outlet name="print"></router-outlet>

@if (!isAuthenticated) {
  <div class="redirect">
    <div class="block">
      <div class="flex-container-center">
        <mat-spinner></mat-spinner>
      </div>
      <div class="spacer-large">
      </div>
      <span>{{ 'common.labels.redirectingToLogin' | transloco }}</span>
    </div>
  </div>
}